import { SimpleCarousel } from '@eventbrite/collection-carousel';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    NearbyPOICard,
    NearbyPOICardProps,
} from '../../components/NearbyPOICard';
import styles from './NearbyPOI.module.scss';

export interface NearbyPOIProps {
    pointOfInterestName: string;
    nearbyPointsOfInterest: Array<NearbyPOICardProps>;
}

export const NearbyPOI = (props: NearbyPOIProps) => {
    const { pointOfInterestName, nearbyPointsOfInterest } = props;
    const HEADER_TEXT = gettext(
        'Points of interest near the %(pointOfInterestName)s',
        { pointOfInterestName },
    );

    // TODO: Add FF logic here
    const SHOULD_DISPLAY_NEARBY_POI = nearbyPointsOfInterest?.length > 0;

    return SHOULD_DISPLAY_NEARBY_POI ? (
        <div className={styles.nearbyPOIContainer}>
            <SimpleCarousel
                headerTitle={<h2>{HEADER_TEXT}</h2>}
                slidesVisible={{ desktop: 4, tablet: 3 }}
                lazilyRenderOffScreenElements={true}
            >
                {nearbyPointsOfInterest?.map(
                    ({ name, photos, url, html_attributions }, idx) => (
                        <NearbyPOICard
                            key={pointOfInterestName + idx}
                            name={name}
                            html_attributions={html_attributions}
                            photos={photos}
                            url={url}
                        />
                    ),
                )}
            </SimpleCarousel>
        </div>
    ) : null;
};
